import React from 'react'
import Lottie from 'react-lottie'
import { Link } from 'react-router-dom';
import animationTree from '../assets/lotties/tree.json'
import useTitle from '../custom/useTitle'
import useDescription from '../custom/useDescription'

function ErrorScreen() {
    useTitle("Errore!");
    useDescription("Errore 404 - Pagina non trovata! Mi dispiace che non sei riuscito a trovare quello che stavi cercando.");
    
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: animationTree,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <div className="section-text" style={{textAlign:"center"}}>
            
           <h4>ERRORE 404!</h4>
           <div style={{display:"flex", maxHeight:"600px", zIndex:"-1"}}>
            <Lottie
                options={defaultOptions}
                style={{maxWidth:"600px", display:"flex", zIndex:"0"}}
            />
           </div>
           
           <h4>Pagina non trovata!</h4>
            <button className="card-button"><Link to="/">Torna in Home</Link></button>
        </div>
    )
}

export default ErrorScreen
